// extracted by mini-css-extract-plugin
module.exports = {"affordableIcon":"Home_affordableIcon__aQuJb","stockImage":"Home_stockImage__tED1k"};